import axiosInstance from "./axiosInstance";
import { ENDPOINTS } from "./endpoints";

export const getHeroSection = async (locale = "en") => {
  const res = await axiosInstance.get(
    `${ENDPOINTS.HERO_SECTION}?locale=${locale}&populate=*`
  );

  return res.data?.data?.[0];
};

// export const getHeroSection = async (locale = "en") => {
//   const res = await axiosInstance.get(
//       `${ENDPOINTS.HERO_SECTION}?locale=${locale}`
//     );
//     console.log('res_', res.data.data)
//   return res.data?.data?.[0];
// };
